import type { IconProps } from '../types/IconProps.ts';
export const GlobeOff: IconProps = {
    name: 'GlobeOff',
    children: [
        `<path d="M21.17 16q.81-1.85.83-4A10 10 0 0 0 8 2.83M4.86 5A10 10 0 0 0 19 19.14M2 12h10M17 12h5" />`,
        `<path d="M15.98 11c-.1-2.52-.62-4.74-1.36-6.36C13.76 2.7 12.76 2 12 2s-1.75.71-2.62 2.64M8.2 9Q8 10.42 8 12c0 2.93.54 5.53 1.38 7.36C10.25 21.3 11.25 22 12 22s1.75-.71 2.63-2.64c.42-.93.77-2.08 1.01-3.36M2 2l20 20" />`,
    ]
};